import React, { useEffect, useRef, useState, useMemo } from "react";
import { createPortal } from "react-dom";
import {
  Overlay,
  Dialog,
  Header,
  Title,
  Desc,
  Actions,
  Button,
  ConfirmLabel,
  ConfirmInput,
  ApiError,
} from "./styles";
import { useTaskStore } from "store/task";
import { ftpAPI } from "api";

const DeleteFtpItem = ({ open, setOpen, user, project }) => {
  const { addTask } = useTaskStore();
  const [confirmText, setConfirmText] = useState("");
  const [apiErr, setApiErr] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    setConfirmText("");
    setApiErr(null);
    const t = setTimeout(() => inputRef.current?.focus(), 0);
    return () => {
      document.body.style.overflow = prevOverflow;
      clearTimeout(t);
    };
  }, [open]);

  const canSubmit = useMemo(
    () => confirmText === "삭제하겠습니다",
    [confirmText]
  );

  const handleDelete = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;

    try {
      setApiErr(null);

      const data = await ftpAPI.unmountProject(project, user);
      addTask({
        name: user,
        id: data?.data.task_id,
        job: `Remove FTP Item`,
        state: "pending",
      });

      setOpen(false);
    } catch (err: any) {
      setApiErr(
        err?.response?.data?.detail ||
          err?.response?.data?.message ||
          err?.message ||
          "삭제에 실패했습니다."
      );
    }
  };

  if (!open) return null;

  return createPortal(
    <Overlay>
      <Dialog
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-item-title"
      >
        <Header>
          <Title id="delete-item-title">Delete FTP Project</Title>
        </Header>

        <Desc>
          <strong style={{ color: "#b91c1c" }}>{project}</strong> 프로젝트를
          삭제하시겠습니까?
          <br />
          아래 입력란에 <strong>삭제하겠습니다</strong> 를 입력하면 진행됩니다.
        </Desc>

        {apiErr && <ApiError role="alert">{String(apiErr)}</ApiError>}

        <form
          onSubmit={handleDelete}
          style={{ display: "grid", gap: 14, marginTop: 12, paddingTop: 8 }}
        >
          <ConfirmLabel>확인 문구 입력</ConfirmLabel>
          <ConfirmInput
            ref={inputRef}
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="삭제하겠습니다"
          />

          <Actions>
            <Button
              type="button"
              onClick={() => setOpen(false)}
              data-variant="ghost"
            >
              취소
            </Button>
            <Button
              type="submit"
              data-variant="primary"
              disabled={!canSubmit}
              style={{ background: "#dc2626" }}
            >
              삭제
            </Button>
          </Actions>
        </form>
      </Dialog>
    </Overlay>,
    document.body
  );
};

export default DeleteFtpItem;
